"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SPOTLIGHT_REPORT_PAGE: [
        {
            entitlement: "B2B2024_SpotlightReportPage",
            launchDarkly: "b2b-spotlight-report-page",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
    SPOTLIGHT_REPORT_EMAIL: [
        {
            entitlement: "B2B2024_SpotlightReportEmail",
            launchDarkly: "b2b-spotlight-report-email",
        },
        {
            launchDarkly: "b2b-app-trustie-access-market-insights",
        },
    ],
};
//# sourceMappingURL=spotlight-report.js.map